import { useCallback, useState } from "react";

/** Per-browser display choices, like theme; never part of an exported budget. */
export function useDisplayPreference(key: string, fallback: boolean) {
  const [value, setValue] = useState(() => {
    try {
      const saved = localStorage.getItem(key);
      return saved === "true" ? true : saved === "false" ? false : fallback;
    } catch {
      return fallback;
    }
  });
  const update = useCallback((next: boolean) => {
    setValue(next);
    try {
      localStorage.setItem(key, String(next));
    } catch {
      // Keep the control usable when the browser cannot remember the choice.
    }
  }, [key]);
  return [value, update] as const;
}
